const _light = 300
const _normal = 400
const _variable = 400
const _medium = 500
const _semibold = 600
const _bold = 700
const _extrabold = 800
const _black = 900
const config = { "light": _light, "normal": _normal, "variable": _variable, "medium": _medium, "semibold": _semibold, "bold": _bold, "extrabold": _extrabold, "black": _black,  }
export { config as default, _light, _normal, _variable, _medium, _semibold, _bold, _extrabold, _black }